/**
 * Converts a payload used to update an entity into a partial payload, by
 * replacing all falsy values with null, except for booleans, in which case
 * if they are `false`, the `false` value gets sent.
 */
export const getPatchPayload = <T extends Partial<Record<keyof T, unknown>>>(
  input: T
): Record<keyof T, unknown | null> =>
  Object.keys(input).reduce((result, key) => {
    const tKey = key as keyof T;
    const value = input[tKey];
    const newValue = typeof value === 'boolean' ? value : value || null;

    return { ...result, [tKey]: newValue };
  }, {} as T);
